"use client";

import { useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useAuthStore } from "./store/authStore";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ProfilePage from "./pages/ProfilePage";
import PlansPage from "./pages/PlansPage";
import PluginPage from "./pages/PluginPage";
import OrderPage from "./pages/OrderPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import Layout from "./components/Layout";
import ConsentPage from "./pages/ConsentPage";
import { setGlobalNavigate } from "./services/navigation"; // Import setGlobalNavigate
import { Toaster } from "react-hot-toast"; // Assuming you use react-hot-toast

// Component to set the global navigate function
function AppInitializer() {
  const navigate = useNavigate();
  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);
  return null; // This component doesn't render anything visually
}

function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <>
      <AppInitializer />{" "}
      {/* This component sets the global navigate function */}
      <Routes>
        <Route
          path="/login"
          element={
            !isAuthenticated ? <LoginPage /> : <Navigate to="/dashboard" />
          }
        />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route
          path="/"
          element={isAuthenticated ? <Layout /> : <Navigate to="/login" />}
        >
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="plans" element={<PlansPage />} />
          <Route path="plugins" element={<PluginPage />} />
          <Route path="orders" element={<OrderPage />} />
          <Route path="consents" element={<ConsentPage />} />
          <Route index element={<Navigate to="/dashboard" />} />
        </Route>
        <Route
          path="*"
          element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />}
        />
      </Routes>
      <Toaster /> {/* Add Toaster for notifications */}
    </>
  );
}

export default App;
